module.exports = __webpack_public_path__ + "media/images/product/c1-f45815a01e91209b11eb5e7b2bb27563.png";